const CARD_ITEMS = [
  {
    tag: '明星',
    title: '某女星被曝隐婚三年，孩子已两岁？知情人晒多张照片',
    excerpt: '多位圈内好友疑似在社交平台暗示此事，粉丝群体反应激烈。事件仍在持续发酵中。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20elegant%20abstract%20composition%20with%20soft%20pink%20and%20gold%20tones%2C%20luxury%20lifestyle%20vibe%2C%20entertainment%20news%20aesthetic%2C%20no%20faces%2C%20editorial%20photography%20style&width=600&height=400&seq=cards-item-01&orientation=landscape',
    time: '3小时前',
    views: '45.6万',
  },
  {
    tag: '网红',
    title: '带货一哥被税务部门约谈？直播间突然停播引网友猜测',
    excerpt: '此前已有多位头部主播因税务问题被查，此次事件引发行业震动。官方尚未回应。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20studio%20ambient%20lighting%20abstract%2C%20warm%20dramatic%20red%20and%20gold%20tones%2C%20ecommerce%20live%20vibe%2C%20no%20people%2C%20professional%20broadcast%20atmosphere&width=600&height=400&seq=cards-item-02&orientation=landscape',
    time: '5小时前',
    views: '38.2万',
  },
  {
    tag: '综艺',
    title: '选秀节目导师现场发飙离席，怒斥节目组恶意剪辑',
    excerpt: '该导师在社交媒体连发三条动态炮轰节目组，粉丝与路人各执一词吵翻天。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20lighting%20abstract%20with%20vibrant%20spotlights%2C%20entertainment%20show%20atmosphere%2C%20dark%20background%20with%20colorful%20light%20beams%2C%20no%20people%2C%20cinematic%20mood&width=600&height=400&seq=cards-item-03&orientation=landscape',
    time: '7小时前',
    views: '29.8万',
  },
  {
    tag: '社会',
    title: '知名企业家私人飞机被曝拖欠停机费，机场已发律师函',
    excerpt: '该企业家近年来频繁登上热搜，名下多家公司已出现经营异常。事件引发广泛讨论。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20corporate%20business%20atmosphere%20with%20warm%20dramatic%20lighting%2C%20dark%20sophisticated%20tones%2C%20luxury%20minimal%20vibe%2C%20no%20people%2C%20editorial%20style&width=600&height=400&seq=cards-item-04&orientation=landscape',
    time: '9小时前',
    views: '22.1万',
  },
  {
    tag: '爆料',
    title: '圈内制作人匿名爆料：某顶流组合即将解散单飞',
    excerpt: '据知情人士透露，成员之间矛盾已持续半年，公司正在评估解散方案。组合粉丝群体陷入恐慌。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20abstract%20with%20breaking%20golden%20light%20rays%2C%20music%20industry%20vibe%2C%20dramatic%20contrast%2C%20no%20faces%2C%20cinematic%20atmosphere%20with%20warm%20highlights&width=600&height=400&seq=cards-item-05&orientation=landscape',
    time: '11小时前',
    views: '19.5万',
  },
  {
    tag: '追踪',
    title: '被实锤造假博主新账号又被扒出，换了马甲继续割韭菜',
    excerpt: '网友火眼金睛，新账号刚运营一个月就被识别。该博主此前已被多个平台封禁。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20investigative%20dramatic%20atmosphere%2C%20dark%20background%20with%20revealing%20warm%20light%2C%20social%20media%20detective%20vibe%2C%20no%20faces%2C%20mysterious%20and%20intriguing%20mood&width=600&height=400&seq=cards-item-06&orientation=landscape',
    time: '13小时前',
    views: '16.8万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            热门爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            最新最热的爆料内容，每天都有新发现
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CARD_ITEMS.map((item) => (
            <article
              key={item.title}
              className="group rounded-lg bg-background-50 border border-background-200/60 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs text-foreground-500">{item.time}</span>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-eye-line mr-1"></i>{item.views}
                  </span>
                </div>
                <h3 className="font-semibold text-sm md:text-base text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.excerpt}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}